// Checkout link prefill (api-v3 CheckoutLinkService), the magic-link handoff (phone, code) and API lookups (curp,
// address autocomplete input, placeId, postalCode) put shopper data in query strings.
const PII_URL_PARAMS = ["email", "phoneNumber", "phone", "street", "city", "state", "postalCode", "curp", "input", "placeId", "code", "name", "firstName", "lastName"]

// Analytics beacons carry the page URL as a param value, so its `?`, `&`, `=` and `#` arrive percent-encoded once per
// level of nesting (`%26`, `%2526`, ...). Group 1 holds the `25`s past the first level.
const piiParam = new RegExp(`(?:[?&]|%((?:25)*)(?:3F|26))(?:${PII_URL_PARAMS.join("|")})(?:=|%(?:25)*3D)`, "gi")

// A value ends at a separator of its own URL or of an outer one, never at one encoded deeper, which is part of the value.
const valueEndAt = (depth: number) => new RegExp(depth === 0 ? `[&#\\s"'<>]` : `[&#\\s"'<>]|%(?:25){0,${depth - 1}}(?:26|23)`, "i")

// Matches in absolute and relative URLs, in URLs nested in another URL's params, and in URLs embedded in text, such as
// an error message or a link's label.
export const redactUrl = (value: string): string => {
  let redacted = ""
  let cursor = 0
  for (const match of value.matchAll(piiParam)) {
    if (match.index < cursor) continue
    const valueStart = match.index + match[0].length
    const depth = match[1] === undefined ? 0 : 1 + match[1].length / 2
    const length = value.slice(valueStart).search(valueEndAt(depth))
    const valueEnd = length === -1 ? value.length : valueStart + length
    if (valueEnd === valueStart) continue
    redacted += `${value.slice(cursor, valueStart)}REDACTED`
    cursor = valueEnd
  }
  return redacted + value.slice(cursor)
}

export const redactPiiTelemetry = (event: object, seen = new WeakSet<object>()): void => {
  if (seen.has(event)) return
  seen.add(event)
  for (const [key, value] of Object.entries(event)) {
    if (typeof value === "string") Reflect.set(event, key, redactUrl(value))
    else if (value && typeof value === "object") redactPiiTelemetry(value, seen)
  }
}
